import React from 'react';
import { ExternalLink } from 'lucide-react';

const NoticesPanel = () => {
  const notices = [
    {
      title: 'Yuva Career Club Notice',
      link: 'https://customer-assets-v7afamib.emergentagent.net/job_solapur-shop-preview/artifacts/ltm7gvxd_Notice1.pdf'
    },
    {
      title: 'Schedule of Admission (Institute Level)',
      link: 'https://davcommercesolapur.com/DAV/Schedule%20of%20Admission%20(Institute%20Level).pdf'
    },
    {
      title: 'Schedule of BCA-I Admission (Against Vacant Seats)',
      link: 'https://davcommercesolapur.com/DAV/Schedule%20of%20BCA-I%20Admission%20(Against%20Vacant%20Seats).pdf'
    },
    {
      title: 'Institute Level Form BCA',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSek5iwt1IE9Ia9MLs4Qce9G5vrdsCC3_pEIcuCnxnuyrGnhRw/viewform',
      isForm: true
    },
    {
      title: 'Against Vacant Seats Form BCA',
      link: 'https://forms.gle/swX3ZF81VWhWom7AA',
      isForm: true
    },
    {
      title: 'Admissions Notice 2024-2025 First Year BCA Institute Level',
      link: 'https://davcommercesolapur.com/DAV/bca_notice-1.jpg'
    },
    {
      title: 'Admissions Notice 2024-2025 First Year BCA Vacant Seats after CAP Rounds(Against CAP)',
      link: 'https://davcommercesolapur.com/DAV/bca_notice-2.jpg'
    }
  ];

  return (
    <div className="bg-[#FF4500] text-white p-6">
      <h3 className="text-2xl font-bold mb-6 border-b-2 border-white pb-2">
        Updates and Notice:
      </h3>
      <div className="space-y-4">
        {notices.map((notice, index) => (
          <div key={index} className="bg-white/10 p-4 rounded hover:bg-white/20 transition-all duration-200">
            <h4 className="font-semibold mb-2">{notice.title}</h4>
            <a
              href={notice.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm bg-white text-[#FF4500] px-4 py-2 rounded hover:bg-gray-100 transition-colors"
            >
              Click here
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoticesPanel;